export default {
    apiKey: "AIzaSyDWRkLb_N7B6tPrnUPyQAX42f8nzGnbWAM",
    authDomain: "ekhoni-daktar-99596.firebaseapp.com",
    databaseURL: "https://ekhoni-daktar-99596.firebaseio.com",
    projectId: "ekhoni-daktar-99596",
    storageBucket: "ekhoni-daktar-99596.appspot.com",
    messagingSenderId: "212710702503",
    appId: "1:212710702503:web:fded9876dfaee9839c4a82",
    measurementId: "G-1BGGQ3FWQY"
}
